<div class="modal solid open">
    <div (click)="close()" class="miniClose cancel icon-HamburgerAppClose"></div>
    <div class="row" style="overflow: auto; height: 35.9375rem; margin-top: 2.5rem; padding-top: 0.625rem">
        <pre><code [highlight]="codeData"></code></pre>
    </div>
</div>
